module.exports = __webpack_public_path__ + "img/ic-quality-check-black.10ea3707.svg";